export default "__VITE_ASSET__CsWlgITa__"